var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShuffle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.716,
    height: 19,
    viewBox: "0 0 21.716 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shuffle_1_",
    "data-name": "shuffle (1)",
    transform: "translate(0 -32.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 34.725)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M21.471,107.682,17.4,104.289a.678.678,0,0,0-1.113.521v2.036H15.151a2.7,2.7,0,0,1-2.3-1.276L8.454,98.54a5.4,5.4,0,0,0-4.6-2.552H0V98.7H3.85a2.7,2.7,0,0,1,2.3,1.276l4.395,7.03a5.4,5.4,0,0,0,4.6,2.552h1.136V111.6a.679.679,0,0,0,.391.615.689.689,0,0,0,.288.064.671.671,0,0,0,.434-.157l4.072-3.393a.678.678,0,0,0,0-1.042Z",
    transform: "translate(0 -95.988)",
    fill: "#003984"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(10.301 32.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M254.05,35.561l-4.072-3.393a.679.679,0,0,0-1.113.521v2.036h-1.136a5.4,5.4,0,0,0-4.6,2.552l-.246.394,1.6,2.561.947-1.516a2.7,2.7,0,0,1,2.3-1.276h1.136v2.036a.678.678,0,0,0,.391.615.688.688,0,0,0,.288.064.678.678,0,0,0,.434-.157L254.05,36.6a.678.678,0,0,0,0-1.042Z",
    transform: "translate(-242.88 -32.012)",
    fill: "#003984"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 42.791)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M7.1,286.164l-.946,1.516a2.7,2.7,0,0,1-2.3,1.276H0v2.714H3.85a5.4,5.4,0,0,0,4.6-2.552l.246-.394Z",
    transform: "translate(0 -286.164)",
    fill: "#003984"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuffle);
export default __webpack_public_path__ + "static/media/shuffle.298cdfec05dd31faa369204ed60ba808.svg";
export { ForwardRef as ReactComponent };